import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DocumentoAccredito, Evento, Persona, Subappalto } from '../../../../shared/interface';
import { Table, TableRowExpandEvent } from 'primeng/table';
import { Subject } from 'rxjs';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { ConfirmationService } from 'primeng/api';
import { ApiService } from '../../../../services/api.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-subappalti-accrediti-backoffice',
  templateUrl: './subappalti-accrediti-backoffice.component.html',
  styleUrls: ['./subappalti-accrediti-backoffice.component.css']
})
export class SubappaltiAccreditiBackofficeComponent {

  constructor(
    private apiService: ApiService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute
  ) {}

  @ViewChild('delete') delete!: ConfirmPopup;

  @Input() visible: boolean = false;
  @Input() subappalti: Subappalto[] = [];
  @Input() evento?: Evento;

  persona?: Persona;
  subappalto?: Subappalto;

  add: boolean = false;
  edit: boolean = false
  
  loading: boolean = false;  

  ngOnChanges(changes: SimpleChanges): void {
    this.subappalti = changes['subappalti']?.currentValue || this.subappalti;
    this.evento = changes['evento']?.currentValue || this.evento;
  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  onOpenDocumento(file: string) {
    this.apiService.openProtectedFile(file);
  }

  onOpenDelete(event: Event, subappalto: Subappalto) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Sei sicuro di voler eliminare il subappalto?`,
      reject: () => this.confirmationService.close(),
      accept: () => {        
        this.apiService.deleteSubappalto(subappalto.id).subscribe({
          next: (data) => this.apiService.setSubappaltiEvento(this.evento?.id!),
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.confirmationService.close()
            this.apiService.message("success", "Eliminazione", "Il subappalto è stato eliminato con successo!")
          }
        })
      },
    });
  }

  onDelete() {
    this.delete.accept();
  }

  onClose() {
    this.delete.reject();
  }  

  onOpenEdit(subappalto: Subappalto) {
    this.subappalto = subappalto;
    this.edit = true;    
  }

  onCloseEdit(close: boolean) {
    this.edit = false;
    this.subappalto = undefined;
  }

  onDownloadDocumenti() {    

    this.loading = true;

    let documenti: any[] = []
    this.subappalti.map(subappalto => {
      documenti.push({file: subappalto.visura_camerale, nome: subappalto.visura_camerale})
      documenti.push({file: subappalto.pos, nome: subappalto.pos})
      documenti.push({file: subappalto.autocertificazione, nome: subappalto.autocertificazione})
    });

    // Recupero la ricevuta
    this.apiService.getZipDocumenti(documenti).subscribe({
      next: (data) => {
        const url = window.URL.createObjectURL(data);
        const a = document.createElement('a');
        a.target = '_blank'
        a.href = url;
        a.download = `documenti.zip`;
        a.click();
        this.loading = false;
        setTimeout(() => window.URL.revokeObjectURL(url), 1000);       
      },
      error: (err) => {
        this.loading = false;
        this.apiService.message('error', 'Errore', err.message)        
      },
    });
  }

}
